import { SmallText } from 'ds/components/typography';
import styled from '@emotion/styled';

export const NoDataWidget = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey3};
`;
